/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Content_TitleInputs */

const en_directory_submit_content_title = /** @type {(inputs: Directory_Submit_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build your listing`)
};

const zh_directory_submit_content_title = /** @type {(inputs: Directory_Submit_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`填写你的收录内容`)
};

/**
* | output |
* | --- |
* | "Build your listing" |
*
* @param {Directory_Submit_Content_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_content_title = /** @type {((inputs?: Directory_Submit_Content_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Content_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_content_title(inputs)
	return zh_directory_submit_content_title(inputs)
});
export { directory_submit_content_title as "directory.submit.content.title" }